export default __webpack_public_path__ + "static/media/bg.a7a9de7b.jpg";